<template>
  <div>
    <div v-if="typeQuestion === 'write_paragraph'" class="border border-dark rounded-lg mb-5 p-8 bg-white">
      <p class="font-weight-bold text-break m-0 p-2">
        {{ groupQuestions[indexQuestion]?.group_question?.description }}
      </p>
      <p class="m-0" style="white-space: pre-line">
        {{ groupQuestions[indexQuestion]?.group_question?.script }}
      </p>
      <img :src="groupQuestions[indexQuestion].group_question.image" alt="">
    </div>
    <div>
      <form class="form" @submit.prevent autocomplete="off">
        <div class="p-5 rounded-lg border  bg-white">
          <div style="display: flex; justify-content: end">
            <div style="display: flex; align-items: center; gap: 4px;" class="mb-3">
              <el-button class="p-2" v-if="indexQuestion > 0"
                style="background-color: #bab9bc; color: #000;font-size: 13px; " @click="prevQuestion">Câu
                trước</el-button>
              <el-button class="p-2" style="background-color: #554B7E; color: #f9f7fb;font-size: 13px"
                @click="nextQuestion" v-if="indexQuestion + 1 < groupQuestions.length">Câu sau</el-button>
            </div>
          </div>
          <div v-if="typeQuestion === 'write_paragraph'"
              style="width: 100%; display: flex; align-items: center; justify-content: space-between; padding:0 14px 20px 14px;">
            <div class="d-flex align-self-center">
              <span style="font-weight: 600;">Chấm điểm</span>
            </div>
          </div>
          <div class="d-flex">
            <div class="d-flex flex-column" :class="typeQuestion === 'write_paragraph' ? 'col-8' : 'col-6'"
              style="gap: 10px">
              <div v-if="typeQuestion === 'record_video'" class=" rounded-sm p-4 text-white"
                style="background-color: #554b7e">
                Record_video
              </div>
              <div v-if="typeQuestion === 'record_audio'" class=" rounded-sm p-4 text-white"
                style="background-color: #554b7e">
                Record_audio
              </div>
              <div v-if="typeQuestion === 'record_video' || typeQuestion === 'record_audio'"
                class="rounded-lg p-5 font-weight-bolder border border-dark" style="background: #f9f7fb">
                <p class="font-weight-bold text-break m-0">
                  {{ groupQuestions[indexQuestion]?.group_question?.description }}
                </p>
                <p class="m-0" style="white-space: pre-line">
                  {{ groupQuestions[indexQuestion]?.group_question?.script }}
                </p>
                <el-image :src="groupQuestions[indexQuestion]?.group_question?.image" fit="fill"
                  v-if="groupQuestions[indexQuestion]?.group_question?.image"></el-image>
                <div v-if="groupQuestions[indexQuestion]?.group_question?.video !== ''"
                  class="rounded-lg overflow-hidden w-full">
                  <video class="rounded" width="320" height="220" controls preload="auto">
                    <source :src="groupQuestions[indexQuestion]?.group_question?.video" type="video/mp4" />
                  </video>
                </div>
                <div v-if="groupQuestions[indexQuestion]?.group_question?.audio !== ''"
                  class="rounded-lg overflow-hidden w-full">
                  <audio class="rounded" controls preload="auto">
                    <source :src="groupQuestions[indexQuestion]?.group_question?.audio" type="audio/ogg" />
                  </audio>
                </div>
              </div>
              <div class="p-5 rounded-lg border border-dark d-flex flex-column" style="background-color: #f9f7fb;">
                <span class="font-weight-bolder flex-fill">Bài làm</span>
                <div v-if="typeQuestion === 'write_paragraph'" class="bg-white p-4 my-5 border border-dark rounded-lg"
                    style="position: relative; display: flex; align-items: center; overflow-y: auto"
                  :style="{ 'height': `${answerHeight}px` }">
                  <div v-for="(comment, index) in getHtmlStudentAnswer" :style="{ 'z-index': index }"
                      style="position: absolute; top: 0; left: 0; padding: 4px 14px;" :key="`span-${index}`">
                                <span v-for="(item, indexItem) in comment" ref="answerRef" :key="`${indexItem}-${index}`">
                      <span v-if="item.type === 1" style="white-space: pre-wrap;background-color:#FBFF2180">{{
                        item?.text }}</span>
                                    <span v-if="item.type === 0" style="white-space: pre-wrap">{{ item.text }}</span>
                      <span v-if="item.type === 2" style="white-space: pre-wrap">{{ item.text
                                      }}</span>
                                </span>
                  </div>
                </div>
                <div v-if="typeQuestion === 'record_video'">
                  <video class="rounded" width="320" height="220" controls preload="auto">
                    <source :src="groupQuestions[indexQuestion]?.student_answer" type="video/mp4" />
                  </video>
                </div>
                <div v-if="typeQuestion === 'record_audio'">
                  <audio class="rounded" controls :key="indexQuestion">
                    <source :src="groupQuestions[indexQuestion]?.student_answer" type="audio/ogg" />
                  </audio>
                </div>
                <div v-if="typeMark !== 10 && currentQuestion?.typeAnswer === WRITE_PARAGRAPH"
                  class="d-flex justify-content-between mt-3" style="gap: 20px; flex-wrap: wrap;">
                  <div class="d-flex flex-column">
                    <label>Task Achievement</label>
                    <div class="w-100">
                      <el-input-number :step-strictly="true" :step="0.5" v-model="currentQuestion.achievement"
                        size="small" :min="0" :max="9" controls-position="right" disabled></el-input-number>
                      </div>
                  </div>
                  <div class="d-flex flex-column">
                    <label>Lexical Resource</label>
                    <div class="w-100">
                      <el-input-number :step-strictly="true" :step="0.5" v-model="currentQuestion.lexical" size="small"
                        :min="0" :max="9" controls-position="right" disabled></el-input-number>
                      </div>
                  </div>
                  <div class="d-flex flex-column">
                    <label>Coherence and Cohesion</label>
                    <div class="w-100">
                      <el-input-number :step-strictly="true" :step="0.5" v-model="currentQuestion.coherence"
                        size="small" :min="0" :max="9" controls-position="right" disabled></el-input-number>
                      </div>
                  </div>
                  <div class="d-flex flex-column">
                    <label>Grammatical Range and Accuracy</label>
                    <div class="w-100">
                      <el-input-number :step="0.5" :step-strictly="true" v-model="currentQuestion.grammatical"
                        size="small" :min="0" :max="9" controls-position="right" disabled></el-input-number>
                      </div>
                  </div>
                  <div>
                    <label>Overall</label>
                    <el-input :value="currentQuestion.totalScore" size="small" disabled />
                  </div>
                </div>
                <div class="d-flex flex-column" v-if="typeMark === 10 && typeQuestion === 'write_paragraph'"
                  style="gap: 8px">
                  <label class="font-weight-boldest ">Điểm toàn bài</label>
                  <ValidationProvider name="Điểm toàn bài" rules="required" v-slot="{ errors }" class="w-100 ">
                    <el-select v-model="groupQuestions[indexQuestion].totalScore" placeholder="Chọn điểm" size="small"
                      style="width: 150px">
                      <el-option v-for="item in selectScore" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                    <div class="fv-plugins-message-container">
                      <div data-field="name" data-validator="notEmpty" class="fv-help-block">
                        {{ errors[0] }}
                      </div>
                    </div>
                  </ValidationProvider>
                </div>
              </div>
            </div>
            <div v-if="typeQuestion === 'write_paragraph'" class="col-4 border border-dark rounded-lg p-4"
              :class="typeQuestion === 'write_paragraph' ? 'col-4' : 'col-6'">
              <div class="d-flex mb-5 overflow-hidden"
                style="align-items: center; justify-content: space-between; font-weight: 700">
                <span>Danh sách nhận xét</span>
              </div>
              <div v-if="listComment?.length > 0" class="rounded-lg  " style="gap: 20px;overflow: auto;height: 300px">
                <div style="overflow: auto; height: 400px">
                  <div class="card px-3 py-3 mb-2" v-for="(comment, index) in listComment" :key="index"
                    @click="selectComment(index)" style="cursor: pointer">
                    <p class="mb-1">{{ index + 1 }}.<span style="background-color:#FBFF2180;
">{{ comment.text }}</span></p>
                    <p>{{ comment.feedback }}</p>
                  </div>
                </div>
              </div>
              <div v-else class="text-center">Chưa có nhận xét</div>
            </div>



            <div v-if="typeQuestion === 'record_video' || typeQuestion === 'record_audio'" class="card col-6 p-8"
              style="gap: 20px; background-color: #f6f4f8">
              <SelectOptionHistory class-name="align-items-center " label="Fluency & Coherence"
                placeholder="Chọn thang điểm" :markValue="groupQuestions[indexQuestion].Fluency_Coherence"
                :typeMark="typeMark" :key="`Fluency & Coherence${indexQuestion}`" />
              <SelectOptionHistory class-name="align-items-center" label="Lexical Resource"
                placeholder="Chọn thang điểm" :markValue="groupQuestions[indexQuestion].Lexical_Resource"
                :typeMark="typeMark" :key="`Lexical Resource${indexQuestion}`" />
              <SelectOptionHistory class-name="align-items-center" label="Grammatical range & Accuracy"
                placeholder="Chọn thang điểm" :markValue="groupQuestions[indexQuestion].Grammatical_Range_Accuracy"
                :typeMark="typeMark" :key="`Grammatical range & Accuracy${indexQuestion}`" />
              <SelectOptionHistory class-name="align-items-center" label="Pronunciation" placeholder="Chọn thang điểm"
                :markValue="groupQuestions[indexQuestion].pronunciation" :typeMark="typeMark"
                :key="`Pronunciation${indexQuestion}`" />
              <div class="d-flex ">
                <div style="line-height: 2">
                  <p class="font-weight-boldest" style="font-size: 16px">Điểm toàn bài</p>
                </div>
                <div class="ml-5" :key="indexQuestion">
                  <div class="w-100 px-4">
                    <el-input :value="groupQuestions[indexQuestion].totalScore" size="small" disabled />
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>

import { selectScore, selectScore9, WRITE_PARAGRAPH } from "@/core/option/selectScore";
import SelectOptionHistory from "@/view/pages/classes/components/history/SelectOptionHistory.vue";
export default {
  data() {
    return {
      indexQuestion: 0,
      commentToAnswer: [],
      answerHeight: 0,
      WRITE_PARAGRAPH: WRITE_PARAGRAPH,
      listComment: [],
    }
  },
  components: { SelectOptionHistory },
  props: {
    groupQuestions: {
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: []
    },
    typeMark: {
      type: Number,
      default: 0
    },
    course_student_id: {
      type: Number,
      default: null,
    }
  },
  mounted() {
    this.commentToAnswer = this.currentQuestion?.commentToAnswer
    this.listComment = this.currentQuestion?.comments
    this.matchHeight()
    this.populateDataFromHistory()
  },
  computed: {
    getHtmlStudentAnswer() {
      let answers = this.groupQuestions[this.indexQuestion]?.student_answer;
      return [...this.listComment?.map(comment => [
        { text: answers.slice(0, comment.index), type: 0 },
        { text: comment.text, type: 1 },
        {
          text: answers.slice(comment.index + comment.text.length),
          type: 0
        },
      ]),
        [{ text: answers, type: 2 }]]
    },
    selectScore() {
      return this.typeMark === 10 ? selectScore : selectScore9
    },
    typeQuestion() {
      return this.groupQuestions[this.indexQuestion]?.group_question?.type
    },
    // clickHighlight() {
    //     this.enableHighlight = true
    // },
    currentQuestion() {
      return this.groupQuestions[this.indexQuestion]
    }
  },
  methods: {
    matchHeight() {
      this.answerHeight = 200;
    },
    prevQuestion() {
      this.indexQuestion -= 1
      this.commentToAnswer = this.currentQuestion.commentToAnswer
      this.populateDataFromHistory()
    },
    nextQuestion() {
      if (this.indexQuestion + 1 < this.groupQuestions.length) {
        this.indexQuestion += 1
        this.commentToAnswer = this.currentQuestion?.commentToAnswer
        this.populateDataFromHistory()
      }
    },
    populateDataFromHistory() {
      // Map data từ score_detail và comments vào các field
      const currentQuestion = this.groupQuestions[this.indexQuestion];

      if (currentQuestion && currentQuestion.score_detail) {
        const scoreDetail = currentQuestion.score_detail;

        // Map score_detail cho record_audio/record_video
        if (currentQuestion.Fluency_Coherence) {
          currentQuestion.Fluency_Coherence.valueOption = scoreDetail.fluency || null;
        }
        if (currentQuestion.Lexical_Resource) {
          currentQuestion.Lexical_Resource.valueOption = scoreDetail.vocabularyRange || null;
        }
        if (currentQuestion.Grammatical_Range_Accuracy) {
          currentQuestion.Grammatical_Range_Accuracy.valueOption = scoreDetail.grammaticalRange || null;
        }
        if (currentQuestion.pronunciation) {
          currentQuestion.pronunciation.valueOption = scoreDetail.pronunciation || null;
        }

        // Map score_detail cho write_paragraph
        if (currentQuestion.typeAnswer === 'write_paragraph') {
          currentQuestion.achievement = scoreDetail['task-achievement'] || null;
          currentQuestion.lexical = scoreDetail['lexical-resource'] || null;
          currentQuestion.coherence = scoreDetail['coherence-and-cohesion'] || null;
          currentQuestion.grammatical = scoreDetail['grammatical-range-and-accuracy'] || null;
        }
      }

      if (currentQuestion && currentQuestion.comments) {
        const comments = currentQuestion.comments;

        // Map comments vào comment field cho record_audio/record_video
        comments.forEach(comment => {
          if (comment.fluency && currentQuestion.Fluency_Coherence) {
            currentQuestion.Fluency_Coherence.comment = comment.fluency;
          }
          if (comment.vocabularyRange && currentQuestion.Lexical_Resource) {
            currentQuestion.Lexical_Resource.comment = comment.vocabularyRange;
          }
          if (comment.grammaticalRange && currentQuestion.Grammatical_Range_Accuracy) {
            currentQuestion.Grammatical_Range_Accuracy.comment = comment.grammaticalRange;
          }
          if (comment.pronunciation && currentQuestion.pronunciation) {
            currentQuestion.pronunciation.comment = comment.pronunciation;
          }
        });
      }

      // Set totalScore từ score field
      if (currentQuestion && currentQuestion.score) {
        currentQuestion.totalScore = currentQuestion.score;
      }
    },
  }
}
</script>

<style lang="scss" scoped></style>
